// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2698":"9c67767e","6075":"da8707a0","9214":"9c67767e"}[chunkId] + ".chunk.css";
};